import React from "react"
import styled from "styled-components"
import { Button, Label, Paragraph } from "buoy-core"
import { fontSize, colors } from "buoy-theme"
import Link from "../../common/components/Link"
import { TERMS_URL, PRIVACY_URL } from "../constants"

const FixedFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${colors.white};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
  padding: 0px 20px 16px;
`

const InnerContainer = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 600px;
`

const ItemRow = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 4px;
`

const Legal = styled(Paragraph)`
  ${fontSize("bodySmall")};
  margin: 0;
  line-height: normal;
`

const OrderButton = styled(Button)`
  margin: 10px 0;
`

const FixedPaymentFooter = ({ heading, item, price, buttonText, onClick }) => (
  <FixedFooter>
    <InnerContainer>
      <Label color="primary">{heading}</Label>
      <ItemRow>
        <Paragraph margin="0">{item}</Paragraph>
        <Paragraph margin="0">${price}</Paragraph>
      </ItemRow>
      <Legal>
        Order valid only on day of purchase.
      </Legal>
      <Legal>
        Access expires at 9PM Pacific / 10PM Mountain.
      </Legal>
      <OrderButton onClick={onClick}>{buttonText}</OrderButton>
      <Legal margin="14px 0 0">
        By placing your order, you agree to Buoy’s{" "}
        <Link href={TERMS_URL} target="_blank">
          Terms & Conditions
        </Link>
        {" and "}
        <Link href={PRIVACY_URL} target="_blank">
          Privacy Policy
        </Link>
      </Legal>
    </InnerContainer>
  </FixedFooter>
)

export { FixedPaymentFooter as default }



// WEBPACK FOOTER //
// ./assets/payment/components/FixedPaymentFooter.js